// helpers
import VScope from '../components/helpers/v-scope.vue';
import VSource from '../components/helpers/v-source.vue';
import VModelSource from '../components/helpers/v-model-source.vue';
import VLoader from '../components/helpers/v-loader.vue';
import VSvgIcon from '../components/helpers/v-svg-icon.vue';
import VVideo from '../components/helpers/v-video.vue';

// forms
import VForm from '../components/v-form.vue';
import VField from '../components/v-field.vue';
import VFieldText from '../components/v-field-text.vue';
import VFieldSelect from '../components/v-field-select.vue';
import VFieldCurrency from '../components/v-field-currency.vue';
import VFieldSearch from '../components/v-field-search.vue';
import VFieldTabs from '../components/v-field-tabs.vue';
import VFieldCheckbox from '../components/v-field-checkbox.vue';
import VFieldCheckList from '../components/v-field-check-list.vue';
import VFieldFile from '../components/v-field-file.vue';
import VFieldRange from '../components/v-field-range.vue';


// Other
import VAtms from '../components/v-atms.vue';
import VAtmCard from '../components/v-atm-card.vue';
import VAction from '../components/v-action.vue';
import VSearch from '../components/v-search.vue';
import VHeader from '../components/v-header.vue';
import VHeaderButtons from '../components/v-header-buttons.vue';
import VContacts from '../components/v-contacts.vue';
import VNavigationLinks from '../components/v-navigation-links.vue';
import VDropdown from '../components/v-dropdown.vue';
import VMenu from '../components/v-menu.vue';
import VSticker from '../components/v-sticker.vue';
import VMobMenu from '../components/v-mob-menu.vue';
import VPanel from '../components/v-panel.vue';
import VCollapse from '../components/v-collapse.vue';
import VShowCollapse from '../components/v-show-collapse.vue';
import VConverter from '../components/v-converter.vue';
import VMobAcc from '../components/v-mob-acc.vue';
import VCollections from '../components/v-collections.vue';
import VVideoCard from '../components/v-video-card.vue';
import VModal from '../components/v-modal.vue';
import VVideoBox from '../components/v-video-box.vue';
import VAppWidget from '../components/v-app-widget.vue';
import VFooterCollapse from '../components/v-footer-collapse.vue';
import VFooterCols from '../components/v-footer-cols.vue';
import VTags from '../components/v-tags.vue';
import VBaseSlider from '../components/v-base-slider.vue';
import VMainSlider from '../components/v-main-slider.vue';
import VMainBanner from '../components/v-main-banner.vue';
import VFeatureCards from '../components/v-feature-cards.vue';
import VCourses from '../components/v-courses.vue';
import VAppSliders from '../components/v-app-sliders.vue';
import VNews from '../components/v-news.vue';
import VNewsCard from '../components/v-news-card.vue';
import VSearchSection from '../components/v-search-section.vue';
import VSearchResult from '../components/v-search-result.vue';
import VFooterLinks from '../components/v-footer-links.vue';
import VSocial from '../components/v-social.vue';
import VBreadcrumbs from '../components/v-breadcrumbs.vue';
import VBillPromo from '../components/v-bill-promo.vue';
import VBriefAdvantages from '../components/v-brief-advantages.vue';
import VPromoBanner from '../components/v-promo-banner.vue';
import VPromoSlider from '../components/v-promo-slider.vue';
import VServicesInfo from '../components/v-services-info.vue';
import VOrderBox from '../components/v-order-box.vue';
import VAcc from '../components/v-acc.vue';
import VFaq from '../components/v-faq.vue';
import VFieldQuestion from '../components/v-field-question.vue';
import VCheckboxIcon from '../components/v-checkbox-icon.vue';
import VSiteSwitch from '../components/v-site-switch.vue';
import VCompareTable from '../components/v-compare-table.vue';
import VInformer from '../components/v-informer.vue';
import VPriceBanner from '../components/v-price-banner.vue';
import VDocs from '../components/v-docs.vue';
import VSmallSlider from '../components/v-small-slider.vue';
import VCreditList from '../components/v-credit-list.vue';
import VAccTabs from '../components/v-acc-tabs.vue';
import VFilter from '../components/v-filter.vue';
import VPageNav from '../components/v-page-nav.vue';
import VMediaContent from '../components/v-media-content.vue';
import VVacancies from '../components/v-vacancies.vue';
import VNewsGrid from '../components/v-news-grid.vue';
import VMap from '../components/v-map.vue';
import VTextPageSection from '../components/v-text-page-section.vue';
import VTextGuideSection from '../components/v-text-guide-section.vue';
import VFrmMessage from '../components/v-form-message.vue';
import VCookies from '../components/v-cookies.vue';
import VTable from '../components/v-table.vue';
import VEstate from '../components/v-estate.vue';
import VTextGuide from '../components/v-text-guide.vue';
import VGallery from '../components/v-gallery.vue';
import VComponents from '../components/v-components.vue';
import VCalculator from '../components/v-calculator.vue';
import VPersonGrid from '../components/v-person-grid.vue';
import VRatesLayout from '../components/v-rates-layout.vue';
import VCoursesList from '../components/v-courses-list.vue';
import VCardsList from '../components/v-cards-list.vue';
import VCardBanner from "../components/v-card-banner.vue";
import VCompleteAdvantages from "../components/v-complete-advantages.vue";
import VBanner from "../components/v-banner.vue";
import VConditions from "../components/v-conditions.vue";
import VMiniAdvantages from "../components/v-mini-advantages.vue";
import VPromoOptions from "../components/v-promo-options.vue";
import VCardsGrid from "../components/v-cards-grid.vue";
import VUsefulLinks from "../components/v-useful-links.vue";

import VSwiperSlider from '../components/v-swiper-slider.vue'; // https://swiperjs.com/vue/
import {SwiperSlide} from 'swiper/vue';

export default {
	// helpers
	'v-scope': VScope,
	'v-source': VSource,
	'v-model-source': VModelSource,
	'v-loader': VLoader,
	'v-svg-icon': VSvgIcon,
	'v-video': VVideo,

	// forms
	'v-form': VForm,
	'v-field': VField,
	'v-field-text': VFieldText,
	'v-field-select': VFieldSelect,
	'v-field-currency': VFieldCurrency,
	'v-field-search': VFieldSearch,
	'v-field-tabs': VFieldTabs,
	'v-field-checkbox': VFieldCheckbox,
	'v-field-check-list': VFieldCheckList,
	'v-field-file': VFieldFile,
	'v-field-range': VFieldRange,

	// Other
	'v-atms': VAtms,
	'v-atm-card': VAtmCard,
	'v-action': VAction,
	'v-header': VHeader,
	'v-header-buttons': VHeaderButtons,
	'v-contacts': VContacts,
	'v-navigation-links': VNavigationLinks,
	'v-dropdown': VDropdown,
	'v-menu': VMenu,
	'v-sticker': VSticker,
	'v-mob-menu': VMobMenu,
	'v-panel': VPanel,
	'v-collapse': VCollapse,
	'v-show-collapse': VShowCollapse,
	'v-converter': VConverter,
	'v-mob-acc': VMobAcc,
	'v-collections': VCollections,
	'v-video-card': VVideoCard,
	'v-modal': VModal,
	'v-video-box': VVideoBox,
	'v-app-widget': VAppWidget,
	'v-search': VSearch,
	'v-footer-collapse': VFooterCollapse,
	'v-footer-cols': VFooterCols,
	'v-tags': VTags,
	'v-base-slider': VBaseSlider,
	'v-main-slider': VMainSlider,
	'v-main-banner': VMainBanner,
	'v-feature-cards': VFeatureCards,
	'v-courses': VCourses,
	'v-app-sliders': VAppSliders,
	'v-news': VNews,
	'v-news-card': VNewsCard,
	'v-search-section': VSearchSection,
	'v-search-result': VSearchResult,
	'v-footer-links': VFooterLinks,
	'v-social': VSocial,
	'v-breadcrumbs': VBreadcrumbs,
	'v-bill-promo': VBillPromo,
	'v-brief-advantages': VBriefAdvantages,
	'v-promo-banner': VPromoBanner,
	'v-promo-slider': VPromoSlider,
	'v-services-info': VServicesInfo,
	'v-order-box': VOrderBox,
	'v-acc': VAcc,
	'v-faq': VFaq,
	'v-field-question': VFieldQuestion,
	'v-checkbox-icon': VCheckboxIcon,
	'v-site-switch': VSiteSwitch,
	'v-compare-table': VCompareTable,
	'v-informer': VInformer,
	'v-price-banner': VPriceBanner,
	'v-docs': VDocs,
	'v-small-slider': VSmallSlider,
	'v-credit-list': VCreditList,
	'v-acc-tabs': VAccTabs,
	'v-page-nav': VPageNav,
	'v-media-content': VMediaContent,
	'v-vacancies': VVacancies,
	'v-news-grid': VNewsGrid,
	'v-filter': VFilter,
	'v-map': VMap,
	'v-text-page-section': VTextPageSection,
	'v-text-guide-section': VTextGuideSection,
	'v-form-message': VFrmMessage,
	'v-cookies': VCookies,
	'v-table': VTable,
	'v-estate': VEstate,
	'v-text-guide': VTextGuide,
	'v-gallery': VGallery,
	'v-components': VComponents,
	'v-calculator': VCalculator,
	'v-person-grid': VPersonGrid,
	'v-rates-layout': VRatesLayout,
	'v-courses-list': VCoursesList,
	'v-cards-list': VCardsList,
	'v-card-banner': VCardBanner,
	'v-complete-advantages': VCompleteAdvantages,
	'v-banner': VBanner,
	'v-conditions': VConditions,
	'v-mini-advantages': VMiniAdvantages,
	'v-cards-grid': VCardsGrid,
	'v-useful-links': VUsefulLinks,
	'v-promo-options': VPromoOptions,

	// plugins
	'v-swiper-slider': VSwiperSlider,
	'v-slide': SwiperSlide
};